import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { RevisionsDetailComponent } from './revisions-detail/revisions-detail.component';
import { RevisionsViewAdminComponent } from './revisions-view-admin/revisions-view-admin.component';
import { RevisionsViewClientComponent } from './revisions-view-client/revisions-view-client.component';
import { SharedModule } from "../shared/shared.module";
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { revisionsReducers } from '../stores/global/revisions/reducers';
import { RevisionsEffets } from '../stores/global/revisions/effects';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { RevisionsDetailDevicesComponent } from './revisions-detail/revisions-detail-devices/revisions-detail-devices.component';
import { RevisionsDetailDocumentsComponent } from './revisions-detail/revisions-detail-documents/revisions-detail-documents.component';
import { RevisionsDetailWearingPartsComponent } from './revisions-detail/revisions-detail-wearing-parts/revisions-detail-wearing-parts.component';
import { installationReducers } from '../stores/global/installations/installation-reducers';
import { InstallationEffets } from '../stores/global/installations/installation-effects';
import { IndicatorsModule } from "@progress/kendo-angular-indicators";
import { employeeReducers } from '../stores/global/employees/employee-reducers';
import { EmployeesEffects } from '../stores/global/employees/employee-effects';
import { ManageDevicesComponent } from './revisions-detail/revisions-detail-devices/manage-devices/manage-devices.component';
import { AddDevicesComponent } from './revisions-detail/revisions-detail-devices/add-devices/add-devices.component';
import { IconsModule } from '@progress/kendo-angular-icons';

@NgModule({
  declarations: [
    RevisionsDetailComponent,
    RevisionsViewAdminComponent,
    RevisionsViewClientComponent,
    RevisionsDetailDevicesComponent,
    RevisionsDetailWearingPartsComponent,
    RevisionsDetailDocumentsComponent,
    ManageDevicesComponent,
    AddDevicesComponent,
  ],
  imports: [
    CommonModule,
    DateInputsModule,
    UploadsModule,
    SharedModule,
    FormsModule,
    IndicatorsModule,
    StoreModule.forFeature('revisions', revisionsReducers),
    StoreModule.forFeature('installations', installationReducers),
    StoreModule.forFeature('employees', employeeReducers),
    EffectsModule.forFeature([RevisionsEffets]),
    EffectsModule.forFeature([InstallationEffets]),
    EffectsModule.forFeature([EmployeesEffects]),
    IconsModule
]
})
export class RevisionsModule { }
